import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventAlertBookingTimeComponent } from './event-alert-booking-time';

@Component({
  selector: 'app-event-alert-booking-time-list',
  templateUrl: './event-alert-booking-time-list.component.html',
  inputs: ['event'],
})
export class EventAlertBookingTimeListComponent extends EventAlertBookingTimeComponent implements OnInit, OnDestroy {}
